module.exports = __webpack_public_path__ + "static/media/reservations.f00e4590.png";